import { render, staticRenderFns } from "./Gamepad.vue?vue&type=template&id=b55cf2c8&scoped=true&"
import script from "./Gamepad.vue?vue&type=script&lang=js&"
export * from "./Gamepad.vue?vue&type=script&lang=js&"
import style0 from "./Gamepad.vue?vue&type=style&index=0&id=b55cf2c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55cf2c8",
  null
  
)

export default component.exports